import { List, ListItem } from '../../../List';

/**
 * TableFeaturesChildList component
 * Used to display a nested list of child feature or tip items.
 * @param {Object} params - The parameters object.
 * @param {Array} params.childrenData - An array of child feature or tip items to be displayed in the list.
 * 
 * @returns {JSX.Element} The rendered TableFeaturesChildList component.
 */
export const TableFeaturesChildList = ({ childrenData }) => (
    <List
        style={{ marginLeft: '1.5em', marginTop: '0.5em' }}
        data={childrenData}
        item={({ dataItem }) => (
            <ListItem key={dataItem.key} style={{ marginBottom: '0.25em' }}>
                <li>
                    <b>{dataItem.heading}</b>{dataItem.description}
                </li>
            </ListItem>
        )}
    />
);
